"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _eventHandlers = require("../../utils/eventHandlers");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "collapsible": "collapsible_29qmHe",
  "collapsing-button": "collapsing-button_x_guF5",
  "collapsingButton": "collapsing-button_x_guF5",
  "button": "button_2mn9wo",
  "disabled-button": "disabled-button_3_iuAw",
  "disabledButton": "disabled-button_3_iuAw",
  "indicator": "indicator_35RIoY",
  "content": "content_3NqNoi",
  "collapsed": "collapsed_3xeg5x",
  "expanded": "expanded_2bGgHH"
}; 
require('./Collapsible.css');
var Collapsible = /*#__PURE__*/function (_React$PureComponent) {
  function Collapsible() {
    var _this;
    (0, _classCallCheck2.default)(this, Collapsible);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Collapsible, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isCollapsed: _this.props.collapsed !== undefined ? _this.props.collapsed : true
    });
    (0, _defineProperty2.default)(_this, "toggleState", function () {
      if (!_this.props.isExpandableOnly) {
        _this.setState(function (prevState) {
          return {
            isCollapsed: !prevState.isCollapsed
          };
        });
      } else if (_this.state.isCollapsed) {
        _this.setState(function (prevState) {
          return {
            isCollapsed: !prevState.isCollapsed
          };
        });
      }
      _this.props.onToggle();
    });
    return _this;
  }
  (0, _inherits2.default)(Collapsible, _React$PureComponent);
  return (0, _createClass2.default)(Collapsible, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.collapsed !== this.props.collapsed) {
        this.setState({
          isCollapsed: nextProps.collapsed
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        children = _this$props.children,
        buttonText = _this$props.buttonText,
        testId = _this$props.testId,
        className = _this$props.className;
      var contentId = "collapsible-content-".concat(id);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testId,
        className: (0, _classnames.default)(styles.collapsible, this.state.isCollapsed ? styles.collapsed : styles.expanded, className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.collapsingButton
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "".concat(testId, "-button"),
        role: "button",
        className: this.state.isCollapsed || !this.props.isExpandableOnly ? styles.button : styles.disabledButton,
        tabIndex: "0",
        "aria-expanded": !this.state.isCollapsed,
        "aria-controls": contentId,
        onKeyDown: (0, _eventHandlers.onEnterKey)(this.toggleState),
        onClick: this.toggleState
      }, buttonText, ' ', /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": true,
        className: styles.indicator
      }, ">"))), /*#__PURE__*/_react.default.createElement("div", {
        id: contentId,
        className: styles.content
      }, children));
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(Collapsible, "propTypes", {
  id: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  testId: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  collapsed: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  isExpandableOnly: _propTypes.default.bool
});
(0, _defineProperty2.default)(Collapsible, "defaultProps", {
  id: '',
  onToggle: function onToggle() {},
  isExpandableOnly: false
});
var _default = exports.default = Collapsible;
//# sourceMappingURL=Collapsible.js.map